
import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import MasterShopSpecifyLayout from 'components/organismos/master/labor/MasterShopSpecifyLayout';

const MasterShopSpecifyPage = () => (
  <SidebarTemplate pageTitle="端末設定">
    <MasterShopSpecifyLayout />
  </SidebarTemplate>
);

export default MasterShopSpecifyPage;
